import { Box } from '@chakra-ui/react';

export function PageContainer({ children }: { children: React.ReactNode }) {
  return <Box py="12px" px="110px" display="flex" flexDirection="column" height="calc(100vh - 88px)" overflow='hidden'>{children}</Box>;
}